<template>
  <div class="row" :class="getClass">
    <div class="col-title">
      <p>{{ this.title }}</p>
    </div>
    <div class="col-data">
      <font-awesome-icon icon="check-circle" title="Telefon" v-if="showYesIcon" class="yes" />
      <font-awesome-icon icon="times-circle" title="Telefon" v-if="showNoIcon" />
      <p v-if="!showYesIcon && !showNoIcon">{{ this.data }}</p>
    </div>
  </div>
</template>
<script>
import { isBoolean } from "util";
export default {
  props: ["title", "data", "extClass"],
  computed: {
    showYesIcon() {
      return isBoolean(this.data) && this.data == true;
    },
    showNoIcon() {
      return isBoolean(this.data) && this.data == false;
    },
    getClass() {
      return this.extClass ? this.extClass : null;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../../scss/global.scss";

.row {
  margin: 0;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid #bebebe;
  background-color: rgb(230, 227, 227);
  &.alternate {
    border-top: none;
    background-color: transparent;
  }
  &.price,
  &.price-vat {
    border: none;
    color: $default-page-color;
    margin: 0.8rem 0;
    padding: 0.8rem 0;
    background: transparent;
    font-size: 2.5rem;
    font-weight: 800;
    div {
      padding: 0.5rem 1rem;
      padding-right: 0;
    }
  }
  div {
    p {
      margin: 0;
      padding: 0;
    }
    padding: 0.5rem 1rem;
  }
  .col-title {
    font-weight: 700;
  }
  .col-data {
    text-align: right;
    svg {
      color: rgb(230, 0, 0);
      background-color: inherit;
      &.yes {
        color: rgb(23, 114, 0);
      }
    }
  }
}
</style>
